import React, { useEffect, useState } from "react";
import { Backdrop, Button, Chip, LogoLoader, Modal, showToast } from "../../../../../components";
import { useLoginUser } from "../../../../../hooks/useLoginUser";
import { pullMonsterCandidateResume } from "../../../../../redux/slices/internalDbES/internalDbESApi";
import { getAllApplicantsDataStart, getCareerBuilderApplicantsDataStart, setStateLoading, revertStateLoading, getMonsterApplicantsDataStart, updateCareerBuilderApplicantsDataStart, updateMonsterApplicantsDataStart } from "../../../../../redux/slices/internalDbES/internalDbESlice";
import { getMonsterResumeImport, addVisitHistoryApi } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { dateFormator } from "../../../../../utils";
import { fixResumeIfEntities } from "../../../../../utils/resumeFixer";
import { getAllIntegrationAccess } from "../../../../../redux/slices/setting/settingApi";
import { useDispatch, useSelector } from "react-redux";
import { setcareerBuilderAccessidStart } from "../../../../../redux/slices/internalDbES/internalDbESlice";
import { setMonsterAccessidStart } from "../../../../../redux/slices/internalDbES/internalDbESlice";
import ProfileMigrationModel from "../../../CommonJobBoards/Modals/ProfileMigrationModel";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";

const actionMap = {
  1: getAllApplicantsDataStart,
  2: getCareerBuilderApplicantsDataStart,
  3: getMonsterApplicantsDataStart
};

const getJobBoardsName = {
  1: "Internal DB",
  2: "Career Builder",
  3: "Monster"
}

// function countKeywordsInResume(htmlResume = "", keywords = []) {
//   if (!htmlResume || !Array.isArray(keywords) || keywords.length === 0) {
//     return [];
//   }

//   const excludeWords = new Set(["and", "or", "not"]);
//   const plainText = htmlResume.replace(/<[^>]*>/g, " ").toLowerCase();
//   const uniqueKeywords = [...new Set(
//     keywords
//       .filter((kw) => typeof kw === "string" && kw.trim())
//       .map((kw) => kw.trim().toLowerCase())
//   )];

//   return uniqueKeywords.map((kw) => {
//     if (excludeWords.has(kw)) {
//       return { title: kw, value: 0 };
//     }
//     const escaped = kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//     const regex = new RegExp(`\\b${escaped}\\b`, "gi");
//     const matches = plainText.match(regex);
//     return {
//       title: kw,
//       value: matches ? matches.length : 0,
//     };
//   });
// }

// function highlightKeywordsInHtmlResume(htmlResume = "", keywords = []) {
//   console.log("htmlResume",htmlResume)
//   console.log("keywords",keywords)
//   if (!htmlResume) { //|| !Array.isArray(keywords) || keywords.length === 0
//     return htmlResume;
//   }
//   const isPlainText = !/<\/?(p|div|span|table|html|body)/i.test(htmlResume);

//   if (isPlainText && !htmlResume.includes("<pre>")) {
//     htmlResume = `<pre>${htmlResume}</pre>`;
//   }
//   // Exclude generic words
//   const fixedResume = fixResumeIfEntities(htmlResume)
//   const excluded = new Set(["and", "or", "not"]);
//   const validKeywords = keywords
//     .filter(
//       (kw) => typeof kw === "string" && kw.trim() && !excluded.has(kw.toLowerCase())
//     )
//     .map((kw) => kw.trim())
//     .sort((a, b) => b.length - a.length);

//   if (validKeywords.length === 0) return fixedResume;

//   // Escape regex special chars and build one combined regex
//   // const escaped = validKeywords.map((kw) =>
//   //   kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
//   // );
//   //const regex = new RegExp(`\\b(${escaped.join("|")})\\b`, "gi");
//   const regex = new RegExp(
//     `(${validKeywords
//       .map(kw =>
//         kw.endsWith("*")
//           ? `\\b${kw.slice(0, -1).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\w*`
//           : `\\b${kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`
//       )
//       .join("|")})`,
//     "gi"
//   );


//   // Replace matches with <mark>
//   const highlighted = fixedResume.replace(regex, (match) => {
//     return `<mark class="highlight">${match}</mark>`;
//   });

//   return highlighted;
// }
function countKeywordsInResume(htmlResume = "", keywords = []) {
  if (!htmlResume || !Array.isArray(keywords) || keywords.length === 0) {
    return [];
  }

  const excludeWords = new Set(["and", "or", "not"]);
  const plainText = fixResumeIfEntities(htmlResume).replace(/<[^>]*>/g, " ").toLowerCase();
  const uniqueKeywords = [...new Set(
    keywords
      .filter((kw) => typeof kw === "string" && kw.trim())
      .map((kw) => kw.trim().toLowerCase())
  )];

  return uniqueKeywords.map((kw) => {
    if (excludeWords.has(kw)) {
      return { title: kw, value: 0 };
    }

    let regex;

    if (kw.endsWith("*")) {
      const stem = kw.slice(0, -1).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

      //  Match repair, repairs, repairing, repaired, repairman etc
      regex = new RegExp(`${stem}\\w*`, "gi");
    } else {
      const escaped = kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const pattern = escaped.replace(/ +/g, "\\s+");
      regex = new RegExp(`\\b${pattern}\\b`, "gi");
    }

    const matches = plainText.match(regex);
    return {
      title: kw,
      value: matches ? matches.length : 0,
    };
  });
}

// function highlightKeywordsInHtmlResume(htmlResume = "", keywords = []) {
//   if (!htmlResume) return htmlResume;

//   const isPlainText = !/<\/?(p|div|span|table|html|body)/i.test(htmlResume);
//   if (isPlainText && !htmlResume.includes("<pre>")) {
//     htmlResume = `<pre>${htmlResume}</pre>`;
//   }

//   const fixedResume = fixResumeIfEntities(htmlResume);
//   const excluded = new Set(["and", "or", "not"]);
//   const validKeywords = keywords
//     .filter((kw) => typeof kw === "string" && kw.trim() && !excluded.has(kw.toLowerCase()))
//     .map((kw) => kw.trim())
//     .sort((a, b) => b.length - a.length);

//   if (validKeywords.length === 0) return fixedResume;

//   const regex = new RegExp(
//     `(${validKeywords
//       .map((kw) =>
//        kw.endsWith("*")
//   ? `\\b${kw.slice(0, -1).replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`
//           : `\\b${kw.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`
//       )
//       .join("|")})`,
//     "gi"
//   );

//   // ✅ Split by HTML tags, only replace in TEXT parts (not inside < > tags)
//   const highlighted = fixedResume.replace(
//     /(<[^>]*>)|([^<]+)/g,
//     (match, tag, text) => {
//       if (tag) return tag; // inside a tag — don't touch it
//       if (text) return text.replace(regex, (m) => `<mark class="highlight">${m}</mark>`);
//       return match;
//     }
//   );

//   return highlighted;
// }
function highlightKeywordsInHtmlResume(htmlResume = "", keywords = []) {
  if (!htmlResume) return htmlResume;

  const isPlainText = !/<\/?(p|div|span|table|html|body)/i.test(htmlResume);
  if (isPlainText && !htmlResume.includes("<pre>")) {
    htmlResume = `<pre>${htmlResume}</pre>`;
  }

  const fixedResume = fixResumeIfEntities(htmlResume);
  const excluded = new Set(["and", "or", "not"]);
  const validKeywords = keywords
    .filter((kw) => typeof kw === "string" && kw.trim() && !excluded.has(kw.toLowerCase()))
    .map((kw) => kw.trim())
    .sort((a, b) => b.length - a.length);

  if (validKeywords.length === 0) return fixedResume;

  // ── 1. Parse HTML into tag/text segments ────────────────────────────────
  const segments = [];
  const splitRegex = /(<[^>]*>)|([^<]+)/g;
  let m;
  while ((m = splitRegex.exec(fixedResume)) !== null) {
    segments.push(
      m[1] ? { type: "tag",  content: m[1] }
            : { type: "text", content: m[2] }
    );
  }

  // ── 2. Build combined text + position map ───────────────────────────────
  // posMap[i] = { segIdx, pos } — where char i in `combined` came from
  //           | null            — synthetic space injected between segments
  let combined = "";
  const posMap  = [];

  for (let si = 0; si < segments.length; si++) {
    if (segments[si].type !== "text") continue;
    const { content } = segments[si];

    // Inject one space between text segments so word boundaries are maintained,
    // but only when neither side already provides whitespace.
    if (combined.length > 0 && !/\s$/.test(combined) && !/^\s/.test(content)) {
      combined += " ";
      posMap.push(null);           // synthetic — belongs to no segment
    }

    for (let ci = 0; ci < content.length; ci++) {
      combined += content[ci];
      posMap.push({ segIdx: si, pos: ci });
    }
  }

  // ── 3. Build regex — spaces in keywords become \s+ ──────────────────────
  //    This lets "technical mechanic" match across a newline or other whitespace.
  const regex = new RegExp(
    `(${validKeywords
      .map((kw) => {
        const base    = kw.endsWith("*") ? kw.slice(0, -1) : kw;
        const escaped = base.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const pattern = escaped.replace(/ +/g, "\\s+"); // ← key change
        return kw.endsWith("*") ? `\\b${pattern}\\w*` : `\\b${pattern}\\b`;
      })
      .join("|")})`,
    "gi"
  );

  // ── 4. Find all matches in combined text ────────────────────────────────
  const allMatches = [];
  let match;
  while ((match = regex.exec(combined)) !== null) {
    allMatches.push({ start: match.index, end: match.index + match[0].length });
  }

  if (allMatches.length === 0) return fixedResume;

  // ── 5. Map each match range back to per-segment highlight ranges ─────────
  // segHighlights: Map<segIdx, Array<{start, end}>>  (local char offsets)
  const segHighlights = new Map();

  for (const { start, end } of allMatches) {
    let i = start;
    while (i < end) {
      const pm = posMap[i];
      if (pm === null) { i++; continue; }          // skip synthetic spaces

      const { segIdx } = pm;
      const startPos   = pm.pos;

      // Advance while still in the same segment
      let j = i + 1;
      while (j < end && posMap[j] !== null && posMap[j].segIdx === segIdx) j++;

      const endPos = posMap[j - 1].pos + 1;

      if (!segHighlights.has(segIdx)) segHighlights.set(segIdx, []);
      segHighlights.get(segIdx).push({ start: startPos, end: endPos });
      i = j;
    }
  }

  // ── 6. Rebuild HTML, injecting <mark> tags into text segments ────────────
  return segments
    .map((seg, si) => {
      if (seg.type === "tag") return seg.content;

      const ranges = segHighlights.get(si);
      if (!ranges || ranges.length === 0) return seg.content;

      ranges.sort((a, b) => a.start - b.start);

      let out = "";
      let cursor = 0;
      for (const { start, end } of ranges) {
        out += seg.content.slice(cursor, start);

        const slice = seg.content.slice(start, end);
        // Don't wrap pure whitespace (e.g. a lone \n between tags)
        out += slice.trim()
          ? `<mark class="highlight">${slice}</mark>`
          : slice;

        cursor = end;
      }
      out += seg.content.slice(cursor);
      return out;
    })
    .join("");
}

const Resume = ({ isOpen, source, showResumeButton = false, candidate, keywords, searchQuery, loading = false, onClose: drawerClose }) => {
  const resumeLink = candidate?.resumes?.at(-1)?.files?.at(-1)?.key ?? "";
  const isDisabled = !resumeLink;
  if (source == "Monster") source = 3;
  const { user } = useSelector((state) => state.auth);
  const orgName = user?.data?.organizationId?.name;
  const isParent = user?.data?.organizationId?.isParent == true;
  const { loginUserUiid } = useLoginUser();
  const dispatch = useDispatch();
  const [getResume, setGetResume] = useState(false);
  const [viewData, setViewData] = useState("");
  const [showOriginal, setShowOriginal] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [saveAccessId, setSaveAccessId] = useState(0);
  const [saveMonsterAccessId, setSaveMonsterAccessId] = useState(0);
  const { careerBuilder } = useSelector((state) => state.internalDbES);
  const {
    total,
    tableResponse,
    fullResponse,
    existingCandidates: existingCandidatesCB,
  } = careerBuilder;
  const [isMergeModel, setIsMergeModel] = useState(false);
  const [cbExistingResponse, setCbExistingResponse] = useState();
  const { monster } = useSelector((state) => state.internalDbES);
  const { tableResponse: mTableResponse, fullResponse: mFullResponse, existingCandidates: mExistingCandidates } = monster;
  const { accessData } = useSelector((state) => state.internalDbES);
  //console.log(accessData)

  //console.log(candidate)
  const handleVisitHistory = async (candidateId) => {
    try {
      if (!candidateId) return;
      await addVisitHistoryApi({
        coll: "VisitHistory",
        payload: {
          candidateId: candidateId,
          addedBy: loginUserUiid,
        },
      });
    } catch (error) {
      console.error("Error logging visit history:", error);
    }
  };
  // Get Resume Helper
  const downloadResumeForCandidate = async () => {
    if (!candidate?.resumeTitle && !candidate?.jobTitle && !candidate?.firstName && !candidate?.uiid) return
    dispatch(setStateLoading());

    switch (source) {
      case 2: {
        const candidateData = {
          accessId: saveAccessId || accessData?.careerBuilder?.[0]?.uiid,
          userId: user?.data?.uiid,
          payload: {
            source: source,
            resumeId: candidate?.resumeId,
            // resumeId: "RQS2C96154NXMT15JD0",
            addedBy: loginUserUiid,
            jobTitle: candidate?.jobTitle || candidate?.resumeTitle,
            skills: keywords //|| "java"
          },
          childCredentials: null,
          isChild: isParent ? false : true
        }

        try {
          const response = await pullMonsterCandidateResume(candidateData);
          const newCandidate = response?.data?.data?.response;

          if (response.success) {
            // Check if candidate already exists — same as reference code
            if (response?.data?.data?.response?.message === "Candidate Already Exists") {
              const existingUiid = response?.data?.data?.response?.existingApplicant?.uiid ;
              if (existingUiid) {
                handleVisitHistory(existingUiid);
              }
              setIsMergeModel(true);
              setCbExistingResponse(response?.data?.data?.response);
            } else {
              // Proceed with update flow
              const uiid = response?.data?.data?.response?.uiid;
              if (uiid) {
                handleVisitHistory(uiid);
              }
              const existing = candidate;
              const existingCandidates = existingCandidatesCB;
              dispatch(
                updateCareerBuilderApplicantsDataStart({
                  existing,
                  newCandidate,
                  tableResponse,
                  fullResponse,
                  existingCandidates,
                })
              );

              showToast("Resume pulled successfully", "success", 2000);
            }
          } else {
            // Failure Case
            drawerClose();
            if (response?.error) {
              showToast(response?.error, "error", 2000);
            } else {
              showToast("Resume pulling unsuccessful.", "error", 2000);
            }
            dispatch(revertStateLoading());
          }
        } catch (error) {
          showToast("Something went wrong", "error", 2000)
          drawerClose();
          dispatch(revertStateLoading());
          console.log(error)
        }
        break
      }
      case "Monster":
      case 3: {
        let firstName
        let lastName
        if (!candidate.firstName) {
          const parts = candidate?.name?.trim().split(" ");
          firstName = parts[0];
          lastName = parts.slice(1).join(" ");
        }
        const candidateData = {
          accessId: saveMonsterAccessId || accessData?.monster?.[0]?.uiid,
          payload: {
            resumeId: candidate?.resumeId,
            resumeBoardId: 1,
            firstName: candidate?.firstName || firstName || "",
            middleName: "",
            lastName: candidate?.lastName || lastName || "-",
            addedBy: loginUserUiid,
            jobTitle: candidate?.experienceJobTitle || candidate?.jobTitle || "N/A",
            // workAuth: "",
            workAuth: `${candidate?.workAuthCountry} ${candidate?.workAuthType}`.trim(),
            workHistory: [
              {
                companyName: candidate?.experienceCompany || "",
                jobDetails: {
                  title: candidate?.experienceJobTitle || ""
                }
              }
            ],
            militaryExp: {},
            educationDetails: [
              {
                degree: candidate?.highestEducation || ""
              }
            ],
            orgName: orgName
          },
          childCredentials: null,
          isChild: isParent ? false : true
        };

        try {
          const response = await getMonsterResumeImport(candidateData);
          // const newCandidate = response?.data?.data?.response;
          // const { old, new: newResponse } = newCandidate;
          const newCandidate = response?.data?.data?.response ?? {};
          const { old = null, new: newResponse = null } = newCandidate;


          if (response.success) {
            // Extract merge fields

            if (old && newResponse) {
              // Show merge modal
              const existingUiid = response?.data?.data?.response?.old?.uiid ?? response?.data?.data?.response?.new?.uiid ;
              if (existingUiid) {
                handleVisitHistory(existingUiid);
              }
              setIsMergeModel(true);
              setCbExistingResponse(newCandidate);
            } else {
              // No merge required → directly update
              const uiid = response?.data?.data?.response?.new?.uiid || response?.data?.data?.response?.uiid;
              if (uiid) {
                handleVisitHistory(uiid);
              }
              const existing = candidate;
              dispatch(updateMonsterApplicantsDataStart({ existing, newCandidate, tableResponse: mTableResponse, fullResponse: mFullResponse, existingCandidates: mExistingCandidates }))
              showToast("Resume pulled successfully", "success", 2000);
            }
          } else {
            drawerClose();
            if (response?.error) {
              showToast(response?.error, "error", 2000);
            } else {
              showToast("Resume pulling unsuccessful.", "error", 2000);
            }
            dispatch(revertStateLoading());
          }
        } catch (error) {
          console.log(error)
          showToast("Something went wrong", "error", 2000)
          drawerClose();
          dispatch(revertStateLoading());
          console.log(error)

        }

        break;
      }
      default:
        console.log("No matching source found.");
    }
    dispatch(revertStateLoading())
  }

  useEffect(() => {
    if (isOpen) {
      const fetchIntegrationAccess = async () => {
        try {
          const params = {
            coll: "IntegrationAccess",
            fil: {
              userId: {
                type: "FIND_INTIGRATION_ACCESS",
                value: loginUserUiid,
                category: 3,
                categoryType: 2,
                status: 1
              },
            },
            useAggregate: true,
          };

          //const response = await getAllIntegrationAccess(params);

          // const accessId = accessData?.careerBuilder?.[0]?.uiid ? accessData?.careerBuilder?.[0]?.uiid : dispatch(setcareerBuilderAccessidStart(params));
          // const status = accessData?.careerBuilder?.[0]?.integrationData?.status ?? null;
          const dispatchData = () => {
            dispatch(setcareerBuilderAccessidStart(params));
            const { accessData } = useSelector((state) => state.internalDbES);
            return {
              status:
                accessData?.careerBuilder?.[0]?.integrationData?.status ?? null,
              accessId: accessData?.careerBuilder?.[0]?.uiid ?? null,
            };
          };

          const accessId =
            accessData?.careerBuilder?.[0]?.uiid ?? dispatchData()?.accessId;
          const status =
            accessData?.careerBuilder?.[0]?.integrationData?.status ??
            dispatchData()?.status;
          setSaveAccessId(accessId);
          if (typeof status !== "undefined") {
            if (status === 1) {
            } else {
              showToast("Career Builder integration access not found. Please contact the administrator", "error");
            }
          } else {
            showToast("Career Builder integration status not found. Please contact the administrator", "error");
          }

        } catch (err) {
        } finally {
        }
      };

      const fetchMonsterIntegrationAccess = async () => {
        try {
          const params = {
            coll: "IntegrationAccess",
            fil: {
              userId: {
                type: "FIND_INTIGRATION_ACCESS",
                value: loginUserUiid,
                category: 3,
                categoryType: 1,
                status: 1
              },
            },
            useAggregate: true,
          };

          // const response = await getAllIntegrationAccess(params);

          // const status = accessData?.monster?.[0]?.integrationData?.status ?? null;
          // const accessId = accessData?.monster?.[0]?.uiid ? accessData?.monster?.[0]?.uiid : dispatch(setMonsterAccessidStart(params));
          // setSaveMonsterAccessId(accessId);
          const dispatchData = () => {
            dispatch(setMonsterAccessidStart(params));
            const { accessData } = useSelector((state) => state.internalDbES);
            return {
              status: accessData?.monster?.[0]?.integrationData?.status ?? null,
              accessId: accessData?.monster?.[0]?.uiid ?? null,
            };
          };
          const status =
            accessData?.monster?.[0]?.integrationData?.status ??
            dispatchData()?.status;
          const accessId =
            accessData?.monster?.[0]?.uiid ?? dispatchData()?.accessId;
          setSaveMonsterAccessId(accessId);
          if (typeof status !== "undefined") {
            if (status === 1) {
            } else {
              showToast("Monster integration access not found. Please contact the administrator", "error");
            }
          } else {
            showToast("Monster integration status not found. Please contact the administrator", "error");
          }

        } catch (err) {
        } finally {
        }
      };
      if (source == 2) {
        fetchIntegrationAccess();
      } else if (source == 3 || source == "Monster") {
        fetchMonsterIntegrationAccess();
      }
    }
  }, []);

  // useEffect(() => {
  //   const fetchIntegrationAccess = async () => {
  //     try {
  //       const params = {
  //         coll: "IntegrationAccess",
  //         fil: {
  //           userId: {
  //             type: "FIND_INTIGRATION_ACCESS",
  //             value: loginUserUiid,
  //             category: 3,
  //             categoryType: 2,
  //           },
  //         },
  //         useAggregate: true,
  //       };

  //       const response = await getAllIntegrationAccess(params);

  //       const status = response?.data?.data?.[0]?.integrationData?.status;
  //       const accessId = response?.data?.data?.[0]?.uiid ?? null;
  //       setSaveAccessId(accessId);
  //       if (typeof status !== "undefined") {
  //         if (status === 1) {
  //         } else {
  //           showToast("Career Builder integration access not found. Please contact the administrator", "error");
  //         }
  //       } else {
  //         showToast("Career Builder integration status not found. Please contact the administrator", "error");
  //       }

  //     } catch (err) {
  //     } finally {
  //     }
  //   };

  //   fetchIntegrationAccess();
  // }, []);

  const checkAndGetIfResumeExists = () => {
    switch (source) {
      case 1: {
        if (candidate?.resumes?.length > 0) {
          const resumesLength = candidate?.resumes?.length;
          const resumeDoc = candidate?.resumes[resumesLength - 1];
          const filesLength = resumeDoc?.files?.length;

          const latestResume = resumeDoc?.files[filesLength - 1]?.html;
          return latestResume || "Resume not available";
        } else { return candidate?.htmlResume || "Resume not available"; }
        break;
      }

      case 2: {
        if (candidate?.resumes?.length > 0) {
          const resumesLength = candidate?.resumes?.length;
          const resumeDoc = candidate?.resumes[resumesLength - 1];
          const filesLength = resumeDoc?.files?.length

          const latestResume = resumeDoc?.files[filesLength - 1]?.html
          return latestResume || "Resume not available"
        } else if(candidate?.uiid){
          if (candidate?.resumes?.length === 0) {
            return  "Resume not available";
          }
        }

        break;
      }
      case 3: {
        if (candidate?.resumes?.length > 0) {
          const resumesLength = candidate?.resumes?.length;
          const resumeDoc = candidate?.resumes[resumesLength - 1];
          const filesLength = resumeDoc?.files?.length

          const latestResume = resumeDoc?.files[filesLength - 1]?.html
          return latestResume || "Resume not available"
        } else if(candidate?.uiid){
          if (candidate?.resumes?.length === 0) {
            return  "Resume not available";
          }
        }

        break;
      }
      default: {
        if (candidate?.resumes?.length > 0) {
          const resumesLength = candidate?.resumes?.length;
          const resumeDoc = candidate?.resumes[resumesLength - 1];
          const filesLength = resumeDoc?.files?.length

          const latestResume = resumeDoc?.files[filesLength - 1]?.html || ""
          return latestResume || "Resume not available"
        } else if(candidate?.uiid){
          if (candidate?.resumes?.length === 0) {
            return  "Resume not available";
          }
        }

        break;
      }
    }
  }


  const resumeDetails = countKeywordsInResume(showOriginal ? viewData : checkAndGetIfResumeExists(), keywords);
  const highlighted = highlightKeywordsInHtmlResume(showOriginal ? viewData : checkAndGetIfResumeExists(), keywords);

  useEffect(() => {
    const exists = checkAndGetIfResumeExists();
    setGetResume((prev) => (prev !== exists ? exists : prev));
  }, [candidate]);

  function extractS3Key(url) {
    return url.replace(/^https?:\/\/[^/]+\//, "");
  }

  const viewResume = async () => {
    // If already fetched, just toggle
    if (hasFetched) {
      setShowOriginal((prev) => !prev);
      return;
    }

    try {
      const query = new URLSearchParams({
        key: extractS3Key(resumeLink),
        coll: "Candidate",
        html: true,
      }).toString();
      const url = `${ENDPOINTS.CANDIDATES.RESUME_URL}?${query}`;
        const response= await axiosRequest({method:"GET",url})
      if (!response.success) {
        showToast("error fetching clear Resume", "error")
        setHasFetched(true);
      }
      const data = `<pre>${response?.data?.data?.htmlContent || ""}</pre>`;
      setViewData(data);
      setHasFetched(true);
      setShowOriginal(true); // switch to original view after fetch
    } catch (error) {
      console.error("Error fetching data:", error);
      setHasFetched(true);
    }
  };


  return !getResume ? (
    <div className="min-h-100 gap-4 flex  flex-col justify-center items-center">
      {showResumeButton && (
        <>
          <p>
            By Clicking here, Credits will be used, and you will unlock the resume.
          </p>

          <Button
            title={"Get the Resume"}
            className="self-center"
            onClick={async () => {
              await downloadResumeForCandidate();
            }}
          />
        </>
      )}
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <Modal
        isOpen={isMergeModel}
        onClose={() => {
          setIsMergeModel(false)
        }}
        title="Applicant Profile Migration"
        titleColor="primary"
        width="max-w-2xl"

      >
        <ProfileMigrationModel
          onCancel={() => {
            // drawerClose();
            setIsMergeModel(false)
          }}
          candidate={candidate}
          data={cbExistingResponse}
          source={source}
        />
      </Modal>
    </div>
  ) : (
    <div className="p-3">
      <div className="flex flex-wrap gap-2 mb-5">
        {Array.from({ length: resumeDetails.length }, (_, i) => (
          <Chip
            label={`${resumeDetails[i]?.title}-${resumeDetails[i]?.value}`}
            color={"info"}
            variant={"contained"}
            className="!bg-gray-50 !py-1 !border !border-info-100 text-info rounded-xl"
          />
        ))}
      </div>
      <div className="flex items-center my-3">
        <span>Migrated by</span>
        <div className="mx-2">
          <Chip
            label={candidate?.addedBy?.firstName}
            color={"success"}
            icon={"person"}
            variant={"contained"}
            size="md"
            className="text-success !px-2"
          />
        </div>
        <span>from</span>
        <div className="mx-2">
          <Chip
            label={getJobBoardsName[candidate?.source]}
            color={"leave"}
            icon={"cloud_download"}
            variant={"contained"}
            size="md"
            className="text-leave !px-2"
          />
        </div>
        <span>from</span>
        <div className="mx-2">
          <Chip
            label={dateFormator(candidate?.addedOn, "datetime-ampm")}
            icon={"calendar_month"}
            color="primary"
            variant={"contained"}
            size="md"
            className="text-primary !px-2"
          />
        </div>
      </div>
      {/* <p>
        Trouble viewing resume?{" "}
        <span className="text-blue-700 font-[700]">Click Here</span>
      </p> */}
      {/* <div className="flex flex-col flex-1 bg-gray-50 rounded p-4">
        <p className="mb-4">
          David J. Mosure, <mark>PE</mark>
          <br />
          Vice President, ms consultants, inc.
        </p>

        <p>
          Mr. Mosure, a professional engineer since 1983, brings 38 years’
          experience with public works infrastructure projects covering nearly
          every branch of
          <mark> construction</mark> administration;
          <mark> civil </mark>, environmental, mechanical and electrical
          engineering...
        </p>
      </div> */}

      <p>
        Trouble viewing resume?{" "}
        <span
            className={`font-[700] ${isDisabled
                ? "text-gray-400 cursor-not-allowed"
                : "text-blue-700 cursor-pointer"
              }`}
            onClick={!isDisabled ? viewResume : undefined}
          >
            {showOriginal ? "View Original Resume" : "View Clear Resume"}
          </span>
      </p>

      <div>
        <div
          dangerouslySetInnerHTML={{
            __html: highlighted,
          }}
        />
      </div>


      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Resume;
